import Immutable from 'seamless-immutable';
import { combineReducers } from 'redux';

import * as actionTypes from './action-types';

const byIdInitialState = Immutable({});

function byId(state = byIdInitialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_ADVISORY.START:
      const { advisoryId: fetchingAdvisoryId } = action.payload;
      return fetchingAdvisoryId
        ? state.merge(
            {
              [fetchingAdvisoryId]: {
                fetching: true,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.FETCH_ADVISORY.SUCCESS:
      const { advisoryId: fetchedAdvisoryId } = action.payload;
      return fetchedAdvisoryId
        ? state.merge(
            {
              [fetchedAdvisoryId]: {
                fetching: false,
                lastFetchedAt: new Date().toISOString(),
                error: null,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.FETCH_ADVISORY.FAILURE:
      const { advisoryId: fetchErrorAdvisoryId, error: fetchError } = action.payload;
      return fetchErrorAdvisoryId
        ? state.merge(
            {
              [fetchErrorAdvisoryId]: {
                fetching: false,
                error: fetchError,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.CHECK_ACCEPT_ADVISORY_STATUS.START:
      const { advisoryId: checkingAcceptAdvisoryStatusOfId } = action.payload;
      return checkingAcceptAdvisoryStatusOfId
        ? state.merge(
            {
              [checkingAcceptAdvisoryStatusOfId]: { checkingAcceptAdvisoryStatus: true },
            },
            { deep: true }
          )
        : state;
    case actionTypes.CHECK_ACCEPT_ADVISORY_STATUS.SUCCESS:
      const { advisoryId: checkedAcceptAdvisoryStatusOfId } = action.payload;
      return checkedAcceptAdvisoryStatusOfId
        ? state.merge(
            {
              [checkedAcceptAdvisoryStatusOfId]: {
                checkingAcceptAdvisoryStatus: false,
                lastCheckedAcceptAdvisoryStatusAt: new Date().toISOString(),
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.CHECK_ACCEPT_ADVISORY_STATUS.FAILURE:
      const { advisoryId: checkedFailedAcceptAdvisoryStatusOfId } = action.payload;
      return checkedFailedAcceptAdvisoryStatusOfId
        ? state.merge(
            {
              [checkedFailedAcceptAdvisoryStatusOfId]: {
                checkingAcceptAdvisoryStatus: false,
              },
            },
            { deep: true }
          )
        : state;
    case actionTypes.ACCEPT_ADVISORY.START:
      const { advisoryId: acceptingAdvisoryId } = action.payload;
      return acceptingAdvisoryId
        ? state.merge({ [acceptingAdvisoryId]: { accepting: true } }, { deep: true })
        : state;
    case actionTypes.ACCEPT_ADVISORY.SUCCESS:
    case actionTypes.ACCEPT_ADVISORY.FAILURE:
      const { advisoryId: acceptedAdvisoryId } = action.payload;
      return acceptedAdvisoryId
        ? state.merge({ [acceptedAdvisoryId]: { accepting: false } }, { deep: true })
        : state;
    case actionTypes.REJECT_ADVISORY.START:
      const { advisoryId: rejectingAdvisoryId } = action.payload;
      return rejectingAdvisoryId
        ? state.merge({ [rejectingAdvisoryId]: { rejecting: true } }, { deep: true })
        : state;
    case actionTypes.REJECT_ADVISORY.SUCCESS:
    case actionTypes.REJECT_ADVISORY.FAILURE:
      const { advisoryId: rejectedAdvisoryId } = action.payload;
      return rejectingAdvisoryId
        ? state.merge({ [rejectedAdvisoryId]: { rejecting: false } }, { deep: true })
        : state;
    case actionTypes.REVOKE_ADVISORY.START:
      const { advisoryId: revokingAdvisoryId } = action.payload;
      return revokingAdvisoryId
        ? state.merge({ [revokingAdvisoryId]: { revoking: true } }, { deep: true })
        : state;
    case actionTypes.REVOKE_ADVISORY.SUCCESS:
    case actionTypes.REVOKE_ADVISORY.FAILURE:
      const { advisoryId: revokedAdvisoryId } = action.payload;
      return revokedAdvisoryId
        ? state.merge({ [revokedAdvisoryId]: { revoking: false } }, { deep: true })
        : state;

    case actionTypes.SOFT_ACCEPT_ADVISORY.START: {
      const { advisoryId } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  accepting: true,
                  rejecting: false,
                  validating: false,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    case actionTypes.SOFT_REJECT_ADVISORY.START: {
      const { advisoryId } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  rejecting: true,
                  accepting: false,
                  validating: false,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    case actionTypes.SOFT_ACCEPT_ADVISORY.SUCCESS:
    case actionTypes.SOFT_REJECT_ADVISORY.SUCCESS: {
      const { advisoryId, softConnection } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  accepting: false,
                  rejecting: false,
                  validating: false,
                  ...softConnection,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    case actionTypes.SOFT_ACCEPT_ADVISORY.FAILURE:
    case actionTypes.SOFT_REJECT_ADVISORY.FAILURE: {
      const { advisoryId, error } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  rejecting: false,
                  accepting: false,
                  validating: false,
                  error: error,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    case actionTypes.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.START: {
      const { advisoryId } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  validating: true,
                  rejecting: false,
                  accepting: false,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    case actionTypes.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.SUCCESS: {
      const { advisoryId } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  validating: false,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    case actionTypes.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.FAILURE: {
      const { advisoryId } = action.payload;
      return advisoryId
        ? state.merge(
            {
              [advisoryId]: {
                softConnection: {
                  validating: false,
                },
              },
            },
            { deep: true }
          )
        : state;
    }
    default:
      return state;
  }
}

const byUserIdInitialState = Immutable({});

function byUserId(state = byUserIdInitialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_ADVISORIES_BY_USER_ID.START:
      const { userId: fetchingUserId } = action.payload;
      return state.merge(
        {
          [fetchingUserId]: {
            fetching: true,
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_ADVISORIES_BY_USER_ID.SUCCESS:
      const { userId: fetchedUserId } = action.payload;
      return state.merge(
        {
          [fetchedUserId]: {
            fetching: false,
            lastFetchedAt: new Date().toISOString(),
            error: null,
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_ADVISORIES_BY_USER_ID.FAILURE:
      const { userId: fetchFailedUserId, error: fetchError } = action.payload;
      return (
        state.merge({
          [fetchFailedUserId]: {
            fetching: false,
            error: fetchError,
          },
        }),
        { deep: true }
      );
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  byUserId,
});



// WEBPACK FOOTER //
// ./src/store/features/users/advisories/reducer.js